import { ContentTypeFilterClause, MixedContentItemDefinition, SpaceDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { DatasourceContentType } from '../ContentTypes';
import { getDataSourceDefaultFilters } from './getDefaultFilters';
import { DatasourceCard } from '../../../app/spaces/CardView/DatasourceCard';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { SpacesSiteUrls } from '../../../app/spaces/SpacesSiteUrls';
import { DataSources } from '../../../content/resources/Datasources';
import { getAngularDatasourceDetailDialogOptions } from '../../../app/spaces/DetailsDialog/AngularContentDetailsDialogOptions';
import { IContentInfo } from '../IContentInfo';
import { call } from 'redux-saga/effects';
import { getDatasourceInfos } from '../../../app/sagas/spaces/SpacesSagaHelpers';
import { IDataSourceInfo } from '../IDataSourceInfo';

export const DatasourceDefinition: MixedContentItemDefinition & SpaceDefinition<'datasource'> = {
  itemType: 'datasource',
  contentType: 'datasource',
  singularName: Messages.datasource,
  pluralName: Messages.datasources,
  emptyStateMessage: Messages.datasourcesEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Datasources,
  contentFilterKeys: DatasourceContentType.filterKeys,
  defaultFilters: getDataSourceDefaultFilters,
  cardComponent: DatasourceCard,
  listViewIconUrl: imgPath('datasource_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['datasource']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.exploreDatasourceUrl(contentId),
  getBasicQuery: () => {
    return DataSources.all().withExtraParams(DatasourceContentType.extraQueryParams);
  },
  fieldValueResourceType: 'datasource',
  getDetailsDialogOptions: getAngularDatasourceDetailDialogOptions,
  getContentInfo: (contentList: IContentInfo[]) => call(getDatasourceInfos, contentList),
  headerIconPath: (contentInfo: IDataSourceInfo) => DataSources.getIconForDatasourceType(contentInfo, 'masthead'),
  supportedDisplayModes: ['list', 'thumbnail'],
};
